import { SUPPORTED_LOCALES } from 'lib/constants.mjs';
import { createNavigation } from 'next-intl/navigation';
import { routing } from './i18n/routing';
export const locales = SUPPORTED_LOCALES;

export const {
	getPathname,
	Link,
	permanentRedirect,
	redirect,
	usePathname,
	useRouter,
} = createNavigation(routing);
